/*
 * Contrato de cliente ObtenerFechaDeNegocioLocal (D-06, RF-013).
 *
 * Existe para que NINGUN modulo le pregunte la fecha al servidor ni la calcule
 * con Date.UTC. El dia de una operacion es la fecha local del dispositivo que la
 * captura, y viaja como AAAA-MM-DD, sin hora y sin desplazamiento.
 *
 * PROHIBIDO en todo el sistema: serializar un Date completo o un ISO con "Z" en
 * un campo de fecha de negocio. Eso reintroduce exactamente el defecto que D-06
 * elimina.
 */

/** Fecha local del dispositivo en formato AAAA-MM-DD. */
export function obtenerFechaDeNegocioHoy(reloj = new Date()) {
  return aFechaDeNegocio(reloj);
}

/** Convierte un Date a fecha de negocio usando los componentes LOCALES, no UTC. */
export function aFechaDeNegocio(fecha) {
  const anio = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getDate()).padStart(2, '0');
  return `${anio}-${mes}-${dia}`;
}

/**
 * Zona IANA detectada del dispositivo. SOLO PARA MOSTRAR en Ajustes, Perfil o
 * diagnostico, y para presentar marcas de auditoria en hora local. No se envia al
 * servidor y no se persiste (D-06, S-07). Si el navegador no la expone, null: el
 * dato informativo simplemente no se muestra.
 */
export function obtenerZonaDetectada() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}

/** Desplazamiento legible de la zona detectada, por ejemplo UTC−06:00. */
export function obtenerDesplazamientoLegible(reloj = new Date()) {
  const minutos = -reloj.getTimezoneOffset();
  const signo = minutos < 0 ? '−' : '+';
  const horas = String(Math.floor(Math.abs(minutos) / 60)).padStart(2, '0');
  const resto = String(Math.abs(minutos) % 60).padStart(2, '0');
  return `UTC${signo}${horas}:${resto}`;
}

/** Periodo AAAAMM de una fecha de negocio, por aritmetica de calendario (RN-016). */
export function resolverPeriodoLocal(fechaDeNegocio) {
  const [anio, mes] = fechaDeNegocio.split('-');
  return Number(anio) * 100 + Number(mes);
}

/** Formato de presentacion dd/MM/aaaa (RNF-015). Recibe una fecha de negocio. */
export function formatearFecha(fechaDeNegocio) {
  if (!fechaDeNegocio) return '';
  const [anio, mes, dia] = fechaDeNegocio.split('-');
  return `${dia}/${mes}/${anio}`;
}

/**
 * Presenta una marca de auditoria (instante UTC) en la zona DETECTADA del
 * dispositivo que muestra la pantalla, no en una zona guardada en el perfil
 * (RNF-003).
 */
export function formatearInstante(instanteUtc) {
  if (!instanteUtc) return '';
  const fecha = new Date(instanteUtc);
  return new Intl.DateTimeFormat('es-MX', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(fecha);
}

/** Importe con separador de miles y dos decimales (RNF-015, RNF-001). */
export function formatearImporte(importe, simbolo = '$') {
  const numero = Number(importe ?? 0);
  return `${simbolo}${numero.toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
